import { useMytaverseEvent } from '@core/dashboard/providers';

/**
 * Shared rule for in-world HUD menus that overlap the branding editor's
 * Inspector panel (right edge). Returns `true` while the editor Inspector is
 * open so the menu can hide/unmount itself and reappear when it closes.
 *
 * Centralizing the flag here (rather than reading `isEditorInspectorOpen`
 * directly in each menu) lets future menus reuse the same rule — see MV-1551.
 * The NOA assistant gates on the same flag (`src/modules/core/assistant`).
 */
export const useHiddenWhileEditing = (): boolean => {
  const { isEditorInspectorOpen } = useMytaverseEvent() || {};
  return !!isEditorInspectorOpen;
};
